import { createEntityHooks } from '../core/createEntityHooks'
import type { BaseDocument } from '../core/types'

/**
 * PageContent document interface
 */
export interface PageContentDocument extends BaseDocument {
  pageId: string
  content: string
  format: string
  length: number
  plainText?: string | null
  version: number
  createdOn: number
  updatedOn: number
  deletedOn?: number | null
}

/**
 * PageContent-specific hooks
 */
const hooks = createEntityHooks<PageContentDocument>('pagecontent')

// Queries by pageId (1:1 relationship)
export const usePageContent = (pageId: string | undefined) => {
  const { data, isLoading } = hooks.useEntities(
    pageId ? { pageId, isDeleted: false } : undefined,
    { enabled: !!pageId },
  )
  return { content: data[0] || null, isLoading }
}

/** All page content rows, for previews in the docs index. */
export const usePageContents = () => {
  const { data, isLoading } = hooks.useEntities({ isDeleted: false })
  return { contents: data, isLoading }
}

export const usePageContentMutations = () => {
  const { create, update, delete: deleteEntity } = hooks.useMutations()
  return {
    createPageContent: create,
    updatePageContent: update,
    deletePageContent: deleteEntity,
  }
}
